export default __webpack_public_path__ + "static/media/11.249c087d.png";